export default __webpack_public_path__ + "static/729-94489e744ce5aaf575e0a433a4ec7222.gif";